import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Camera, Film, MonitorPlay, ArrowRight } from "lucide-react";
const milestones = [{
  label: "Precision",
  value: "Hardwood vs Evergreen",
  icon: Camera
}, {
  label: "Technology",
  value: "Tree Size and Stand Structure",
  icon: Film
}, {
  label: "Turnaround",
  value: "Density and Spacing",
  icon: MonitorPlay
}, {
  label: "New",
  value: "Terrain and Operability",
  icon: Camera
}];
export default function AboutMe() {
  return <section data-section-id="226517" id="whatyoullunderstand" className="bg-background text-foreground py-24 lg:py-32 relative overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="lg:col-span-5 relative group">
            <div className="relative overflow-hidden bg-muted rounded-sm border-[0.5px] border-border/50 shadow-xl">
              <AspectRatio ratio={3 / 4}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645510/img/gtmx_lidar_forest_scan.png" alt="GTMX Labs LiDAR Forest Analysis" className="object-cover w-full h-full transition-transform duration-1000 ease-out group-hover:scale-105 contrast-110 brightness-90" />
                {}
                <div className="absolute inset-0 opacity-20 mix-blend-overlay pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645510/img/gtmx_tech_grid.png')] bg-cover bg-center" aria-hidden="true" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent pointer-events-none" />
              </AspectRatio>
            </div>
            
            {}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 border-b-2 border-r-2 border-primary/30 pointer-events-none hidden md:block" />
            <div className="absolute -top-6 -left-6 w-24 h-24 border-t-2 border-l-2 border-primary/30 pointer-events-none hidden md:block" />
          </div>

          {}
          <div className="lg:col-span-7 flex flex-col items-start">
            <div className="mb-8">
              <h2 className="font-default text-4xl md:text-6xl lg:text-7xl uppercase tracking-tight font-bold text-foreground leading-none mb-4">
                What You'll Understand
              </h2>
              <p className="font-mono text-primary uppercase tracking-[0.2em] text-sm md:text-base font-semibold">
                Timber Cruise Analysis (TCA)
              </p>
            </div>

            

            <Separator className="mb-12 bg-border/40 w-full max-w-2xl" />

            {}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-full max-w-2xl mb-14">
              {milestones.map((milestone, i) => <div key={i} data-index={i} className="flex flex-col items-start gap-3">
                  <milestone.icon className="size-6 text-primary" strokeWidth={1.5} />
                  <div>
                    <p className="font-default text-3xl md:text-2xl font-bold text-foreground mb-1">
                      {milestone.value}
                    </p>
                    
                  </div>
                </div>)}
            </div>

            {}
            <Button asChild size="lg" className="rounded-none h-14 px-8 font-mono uppercase tracking-widest text-xs transition-all bg-primary text-primary-foreground hover:bg-primary/90 hover:pl-6 hover:pr-10 group">
              
            </Button>
          </div>

        </div>
      </div>
    </section>;
}